import React, { useEffect } from 'react';
import { Card, Label } from './primitives';

/* Each tweet keeps its own video/photo; data-conversation="none" drops the
   reply thread so the embeds stay comparable. The cards are square and equal
   in size — two on the top row, the third centred underneath — and the embed
   scrolls inside its box, since a tweet with a video is taller than a square
   at this width. The blockquote markup is the fallback the widget replaces. */

const posts = [
  {
    id: '2005274676503937306',
    date: 'December 28, 2025',
    body: (
      <>
        We won 50k by just pitching our idea. <br />
        <br />
        We are building HealthNivaran and the idea has morphed completely since then. <br />
        <br />
        Started as AI doctor to now building AI agents for the Doctors. <br />
        <br />
        Learned a lot during journey
        <br />
        - No AI can replace Nuanced care <br />
        - Healthcare is considered a&hellip;{' '}
        <a href="https://t.co/Y3cDBGygQs">pic.twitter.com/Y3cDBGygQs</a>
      </>
    ),
  },
  {
    id: '2003885572465872955',
    date: 'December 24, 2025',
    body: (
      <>
        Sent this in a group of 300 hospitals owners :) <br />
        <br />
        HealthNivaran is now offering its solution for white label, Your hospital name, Your number
        and our logic...
        <br />
        <br />
        Takes care of all FrontDesk queries
        <br />
        - In hindi/english etc
        <br />
        - Share voice message, Image and pdfs <br />
        - Undestand Insurance{' '}
        <a href="https://t.co/usNqSCeokM">pic.twitter.com/usNqSCeokM</a>
      </>
    ),
  },
  {
    id: '2002726205527818529',
    date: 'December 21, 2025',
    body: (
      <>
        Working out of <a href="https://twitter.com/ns?ref_src=twsrc%5Etfw">@ns</a> (Network School){' '}
        <br />
        <br />
        3 weeks into NS
        <br />
        - Got One Freelance Client <br />
        - International Exposure <br />
        - Played Poker and other card Games
        <br />
        - Learned Swimming <br />- Met{' '}
        <a href="https://twitter.com/balajis?ref_src=twsrc%5Etfw">@balajis</a> had a chat over US vs
        Indian Healthcare
        <br />
        <br />
        This was my first International trip and I am loving this.{' '}
        <a href="https://t.co/LeCvTCdVTK">pic.twitter.com/LeCvTCdVTK</a>
      </>
    ),
  },
];

const XPosts = () => {
  useEffect(() => {
    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load();
    }
  }, []);

  return (
    <section id="posts" className="py-16 sm:py-24 bg-cream scroll-mt-20">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Label className="mb-3">Founder diaries</Label>
        <h2 className="text-2xl sm:text-4xl font-bold text-ink tracking-[-0.02em] mb-9 sm:mb-10">
          From the HealthNivaran days
        </h2>

        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6">
          {posts.map((post, i) => (
            <Card
              key={post.id}
              className={`p-4 sm:aspect-square overflow-y-auto overflow-x-hidden [&_.twitter-tweet]:!my-0 ${
                i === posts.length - 1
                  ? 'sm:col-span-2 sm:w-[calc(50%-0.75rem)] sm:justify-self-center'
                  : ''
              }`}
            >
              <blockquote
                className="twitter-tweet"
                data-theme="light"
                data-conversation="none"
                data-align="center"
                data-width="100%"
              >
                <p lang="en" dir="ltr">
                  {post.body}
                </p>
                &mdash; Shashank Dixit (@ShashankDixit_x){' '}
                <a
                  href={`https://twitter.com/ShashankDixit_x/status/${post.id}?ref_src=twsrc%5Etfw`}
                >
                  {post.date}
                </a>
              </blockquote>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default XPosts;
